/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_themeBase/_helpers";



export const RoomReservActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    {
        openReservRoomDialog, openStudentsRoomDialog, openRoomFacilityDialog
    }
) => (
    <>
        <OverlayTrigger
            overlay={<Tooltip id="objects-edit-tooltip">انتخاب اتاق</Tooltip>}
        >
            <a
                className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                onClick={() => openReservRoomDialog(row.id)}
            >
                <span className="svg-icon svg-icon-md svg-icon-success">
                    <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Devices/Server.svg")}
                    />
                </span>
            </a>
        </OverlayTrigger>
        <> </>
        <OverlayTrigger
            overlay={<Tooltip id="objects-student-tooltip">دانشجویان</Tooltip>}
        >
            <a
                className="btn btn-icon btn-light btn-hover-info btn-sm mx-3"
                onClick={() => openStudentsRoomDialog(row.id)}
            >
                <span className="svg-icon svg-icon-md svg-icon-info">
                    <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")}
                    />
                </span>
            </a>
        </OverlayTrigger>
        <> </>
        <OverlayTrigger
            overlay={<Tooltip id="objects-facility-tooltip">امکانات اتاق</Tooltip>}
        >
            <a
                className="btn btn-icon btn-light btn-hover-warning btn-sm mx-3"
                onClick={() => openRoomFacilityDialog(row.id)}
            >
                <span className="svg-icon svg-icon-md svg-icon-warning">
                    <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Tools/Tools.svg")}
                    />
                </span>
            </a>
        </OverlayTrigger>
    </>
);
